import { theme } from '../theme.js';
import { expiryState, expiryColors, formatDate } from '../lib/unit.js';

/** A qualification code as a small chip; amber when expiring soon, red when expired. */
export function QualChip({ code, grade, expiresAt, title }: {
  code: string; grade?: string | null; expiresAt?: string | null; title?: string;
}) {
  const state = expiryState(expiresAt);
  const c = expiryColors(state);
  const hint = expiresAt
    ? `${state === 'expired' ? 'Expired' : 'Expires'} ${formatDate(expiresAt)}`
    : undefined;
  return (
    <span
      title={[title, grade, hint].filter(Boolean).join(' · ') || undefined}
      style={{
        display: 'inline-block', fontSize: 10, fontWeight: 700, letterSpacing: 0.2,
        padding: '2px 6px', borderRadius: 6, background: c.bg, color: c.fg,
        fontFamily: theme.font, whiteSpace: 'nowrap',
      }}
    >
      {code}{grade ? ` · ${grade}` : ''}{state === 'expired' ? ' · expired' : state === 'soon' ? ' · expiring' : ''}
    </span>
  );
}
